import React, { useEffect, useState, } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import DenseAppBar from '../../components/AppBar'
import { getCurrency, getDateTime } from '../../helpers/Functions'
import PrimaryTheme from '../../Themes/Primary'
import { Step, Stepper } from 'react-form-stepper';
import HorizontalLabelPositionBelowStepper from '../../components/stepper'
import { Icon } from '@material-ui/core'
import AlertModal from '../../components/Modal'
import { useDispatch } from 'react-redux'
import { Reducers } from "../../Interfaces/Interfaces"
import FloatFinanceRepaymentForm from '../../components/FloatFinanceRepaymentForm'
import SuccessImage from "../../images/Dashboard-success-icon.png"
import { useSnackbar } from 'notistack'
import { Link } from "react-router-dom"
import { getFloatFinanaceActionDetails, remindAgentAction } from '../../redux/actions/FloatFinanceAction'
export default function FloatDetails() {
    const { enqueueSnackbar } = useSnackbar();
    const alert = useSelector((state: Reducers) => state.alert);
    const params: any = useParams();
    const floatFinanceDetails = useSelector((state: any) => state.floatFinanceDetails)

    const history = useHistory();
    const [RepaymentModal, setRepaymentModal] = React.useState(false);
    const dispatch = useDispatch()
    const [loader, setloader] = useState(false)
    const [repaymentFormSuccess, setrepaymentFormSuccess] = useState(false)
    const [sendReminderSuccess, setsendReminderSuccess] = useState(false)
    const [seandReminderCheck, setseandReminderCheck] = useState(false)
    const handleAlertModal = () => {
        setsendReminderSuccess(false)
        setrepaymentFormSuccess(false)
        setRepaymentModal(false)
        dispatch({
            type: 'ALERT_MODAL',
            payload: true
        });
    }

    const handleRepayment = () => {
        setseandReminderCheck(false)
        setRepaymentModal(true)
        dispatch({
            type: 'ALERT_MODAL',
            payload: true
        });
    }

    // const id = params.id

    React.useEffect(() => {
        dispatch({
            type: 'LOADING',
            payload: true
        });

        if (Object.entries(alert).length !== 0) {
            setloader(false)
            if (!alert.successful) {
                setRepaymentModal(false)
                enqueueSnackbar(alert.message, { variant: "error" });
                dispatch({
                    type: 'ALERT',
                    payload: {}
                });
                dispatch({
                    type: 'ALERT_MODAL',
                    payload: true
                });
                setRepaymentModal(true)
            } else {
                if (alert.successful) {
                    setRepaymentModal(false)
                    setsendReminderSuccess(true)
                    // dispatch({
                    //     type: 'ALERT_MODAL',
                    //     payload: false
                    // });


                    enqueueSnackbar("Success", { variant: "success" });
                    dispatch({
                        type: 'ALERT',
                        payload: {}
                    });
                    if (seandReminderCheck) {
                        setrepaymentFormSuccess(false)
                    } else {
                        setrepaymentFormSuccess(true)
                    }
                }
            }
        }

    }, [dispatch, alert, loader])
    React.useEffect(() => {

        dispatch(getFloatFinanaceActionDetails(params.id))
        return () => {
            dispatch({
                type: "FLOAT_FINANCE_DETAILS",
                payload: {},
            });
        }
    }, [dispatch, alert, loader])
    const handleSendReminder = () => {
        setseandReminderCheck(true)
        setloader(true)
        let id = floatFinanceDetails.id

        dispatch(remindAgentAction(id))
    }
    const backToFloat = () => {
        dispatch({
            type: 'ALERT_MODAL',
            payload: false
        });
        history.push("/float-finance")
    }
  
    return (
        <div>
            <AlertModal>
                {
                    RepaymentModal ? <FloatFinanceRepaymentForm /> : <div>
                        <div className="alert-image" style={{ paddingTop: "100px", marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                            <img src={SuccessImage} alt="success_logo" />
                        </div>
                        <h2 style={{ fontSize: PrimaryTheme.fontSizes?.subtitle, color: PrimaryTheme.success, width: "100%", textAlign: "center" }}>{repaymentFormSuccess ? "Repayment Confirmed Successfully" : sendReminderSuccess ? "Remainder  Sent Successfully" : "Send Repayment Reminder"}</h2>
                        <h6 style={{ fontSize: PrimaryTheme.fontSizes?.normal, color: "#818e94", width: "100%", textAlign: "center", paddingLeft: "21%", paddingRight: "21%" }}>
                            {
                                repaymentFormSuccess ? "The loan repayment by your agent has been confirmed as successfully repaid. " : sendReminderSuccess ? "The loan repayment  reminder has been sent  to your agent" : " A loan repayment reminder would be sent to your agent."
                            }
                        </h6>
                        <div style={{ paddingTop: "60px", paddingBottom: "40px", width: "100%", display: "flex", justifyContent: "center" }}>
                            {repaymentFormSuccess ? <button type="button" style={{
                                borderRadius: "20px 20px 20px 20px",
                                width: "50%",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                background: PrimaryTheme.warn,
                                color: PrimaryTheme.black,
                                border: "none"

                            }} onClick={backToFloat}>Back to Dashboard</button> : sendReminderSuccess ? <button type="button" style={{
                                borderRadius: "20px 20px 20px 20px",
                                width: "50%",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                background: PrimaryTheme.warn,
                                color: PrimaryTheme.black,
                                border: "none"

                            }} onClick={backToFloat}>Back to Dashboard</button> : loader ? <button type="button" style={{
                                borderRadius: "20px 20px 20px 20px",
                                width: "50%",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                background: PrimaryTheme.warn,
                                color: PrimaryTheme.black,
                                border: "none"

                            }} >Please wait...</button> : <button type="button" style={{
                                borderRadius: "20px 20px 20px 20px",
                                width: "50%",
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                background: PrimaryTheme.warn,
                                color: PrimaryTheme.black,
                                border: "none"

                            }} onClick={handleSendReminder}>Send Reminder</button>}

                        </div>
                    </div>
                }

            </AlertModal>
            <div className="col-md-11 mr-auto ml-auto p-0" style={{
                height: 'auto',
                position: "relative",
            }}>

                <DenseAppBar
                    onClick={() => history.goBack()}
                    canGoBack
                />
            </div>
            <div className="col-md-11 ml-auto mr-auto p-0 mb-2"
                style={{
                    backgroundColor: PrimaryTheme.white,
                    height: "100vh",
                    position: "relative",
                   

                }}>
                <h1
                    className="mb-5 float-title"
                    style={{
                        fontFamily: PrimaryTheme.fonts?.MediumFont,
                        textTransform: "uppercase",
                        fontSize: PrimaryTheme.fontSizes?.subtitle,
                    }}
                >
                    FINANCE TRANSACTION DETAILS
                </h1>
                <div className="col-md-9 ml-auto mr-auto" style={{ background: "white", paddingBottom:"70px" }}>
                    <h6
                        className="text-center col-10"

                        style={{
                            fontFamily: PrimaryTheme.fonts?.MediumFont,
                            color: PrimaryTheme.primary,
                            textTransform: "uppercase",
                            fontSize: PrimaryTheme.fontSizes?.normal,
                        }}
                    >
                        Amount
                    </h6>
                    <h4 className="text-center col-10">
                        {floatFinanceDetails && floatFinanceDetails.amountRequested ? getCurrency(floatFinanceDetails.amountRequested) : "--"}
                    </h4>
                    <div className="col-10">
                        <HorizontalLabelPositionBelowStepper />
                    </div>
                    {/* <Stepper activeStep={1}>
                        <Step label="Children Step 1" />
                        <Step label="Children Step 2" />
                        <Step label="Children Step 3" />

                    </Stepper> */}
                    <div className="row">
                        <div className="col-md-7 mb-4">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.primary,
                                    textTransform: "uppercase",
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Reference
                            </h5>

                            <p>{floatFinanceDetails && floatFinanceDetails.requestReference ? floatFinanceDetails.requestReference : "--"}</p>
                        </div>
                        <div className="col-md-7 mb-3 ">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    textTransform: "uppercase",
                                    color: PrimaryTheme.primary,
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Type
                            </h5>

                            <p>
                                {floatFinanceDetails && floatFinanceDetails.loanName ? floatFinanceDetails.loanName : "--"}
                            </p>
                        </div>
                        <div className="col-md-5">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    textTransform: "uppercase",
                                    color: PrimaryTheme.primary,
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Status
                            </h5>

                            <p> {floatFinanceDetails && floatFinanceDetails.applicationStatusName ? floatFinanceDetails.applicationStatusName : "--"}</p>
                        </div>

                        <div className="col-md-7 mb-3 ">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    textTransform: "uppercase",
                                    color: PrimaryTheme.primary,
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Sender
                            </h5>

                            <p className="mb-0 pb-0">
                                {"--"}
                            </p>

                        </div>
                        <div className="col-md-5 fs-6">
                            <h5
                                className="fs-6"
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.primary,
                                    textTransform: "uppercase",
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Receiver
                            </h5>
                            <p className="mb-0 pb-0">
                                {"--"}
                            </p>
                            <span
                                style={{
                                    color: PrimaryTheme.light,
                                }}
                            >
                                {"--"}
                            </span>
                        </div>
                        <div className="col-md-7 mb-3 ">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    textTransform: "uppercase",
                                    color: PrimaryTheme.primary,
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Channel
                            </h5>

                            <p>
                                {"--"}
                            </p>
                        </div>
                        <div className="col-md-5">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.primary,
                                    textTransform: "uppercase",
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Date
                            </h5>

                            <p>
                                {floatFinanceDetails && floatFinanceDetails.dateRequested ? getDateTime(floatFinanceDetails.dateRequested) : "--"}
                            </p>
                        </div>
                        <div className="col-md-7 mb-3 ">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    textTransform: "uppercase",
                                    color: PrimaryTheme.primary,
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Description
                            </h5>

                            <p>
                                {"--"}
                            </p>
                        </div>
                        <div className="col-md-5">
                            <h5
                                style={{
                                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                                    color: PrimaryTheme.primary,
                                    textTransform: "uppercase",
                                    fontSize: PrimaryTheme.fontSizes?.normal,
                                }}
                            >
                                Charge
                            </h5>

                            <p>
                                {"--"}
                            </p>
                        </div>
                        {
                            floatFinanceDetails.applicationStatusName === "Declined" ? "" : <div className="col-md-10" style={{ paddingTop: "20px", paddingBottom: "20px", display: "flex", justifyContent: "center" }}>
                                <button style={{ background: PrimaryTheme.warn, paddingTop: "10px", paddingBottom: "10px", width: "40%", borderRadius: "26px", border: "none", fontWeight: 500 }} onClick={handleAlertModal} className="remind__agent__button"><Icon fontSize="small" className="mr-2">refresh</Icon>Remind Agent</button>
                            </div>
                        }

                        {
                            floatFinanceDetails.applicationStatusName === "Declined" ? "" : <div className="col-md-10 col-12" style={{
                                paddingTop: "20px", paddingBottom: "30px", textAlign: "center",
                                color: PrimaryTheme.light,
                            }} >
                                <span onClick={handleRepayment}  style={{ cursor: "pointer", }}>
                                    Confirm Repayment via other channels
                                </span>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}
